import {
  BsEnvelopeCheck,
  BsEnvelopeHeart,
  BsEnvelopeOpen,
  BsEnvelopePlus,
  BsEnvelopeSlash,
  BsArrowLeft,
  BsArrowRight,
  BsListTask,
  BsEnvelope,
  BsBuilding,
} from "react-icons/bs";
import {
  FaBriefcase,
  FaBuilding,
  FaCakeCandles,
  FaCcMastercard,
  FaCcPaypal,
  FaCcVisa,
  FaChrome,
  FaEdge,
  FaFacebook,
  FaFirefoxBrowser,
  FaInternetExplorer,
  FaLinkedin,
  FaLock,
  FaOctopusDeploy,
  FaOpera,
  FaPlane,
  FaSafari,
  FaTwitter,
  FaUmbrellaBeach,
  FaUsers,
  FaYoutube,
  FaPlay,
} from "react-icons/fa6";

import {
  FiActivity,
  FiAirplay,
  FiAlertCircle,
  FiArchive,
  FiArrowDown,
  FiArrowUp,
  FiAtSign,
  FiAward,
  FiBarChart2,
  FiBell,
  FiBellOff,
  FiBluetooth,
  FiBriefcase,
  FiCast,
  FiCheck,
  FiClipboard,
  FiClock,
  FiCompass,
  FiCopy,
  FiCrosshair,
  FiDelete,
  FiDollarSign,
  FiEdit,
  FiEye,
  FiEyeOff,
  FiFacebook,
  FiFigma,
  FiFileText,
  FiFramer,
  FiGitBranch,
  FiGitCommit,
  FiGithub,
  FiGitlab,
  FiGlobe,
  FiGrid,
  FiHelpCircle,
  FiInstagram,
  FiLayers,
  FiLayout,
  FiLifeBuoy,
  FiLink,
  FiLink2,
  FiLinkedin,
  FiList,
  FiLock,
  FiLogIn,
  FiMail,
  FiMapPin,
  FiMessageSquare,
  FiMonitor,
  FiMoon,
  FiPause,
  FiPhone,
  FiPieChart,
  FiPlusSquare,
  FiPower,
  FiRepeat,
  FiSearch,
  FiSend,
  FiSettings,
  FiShield,
  FiShoppingBag,
  FiShoppingCart,
  FiSliders,
  FiSmartphone,
  FiStar,
  FiSun,
  FiSunrise,
  FiSunset,
  FiTablet,
  FiTag,
  FiTrash2,
  FiTwitter,
  FiType,
  FiUmbrella,
  FiUser,
  FiUserCheck,
  FiUserMinus,
  FiUserPlus,
  FiUsers,
  FiX,
  FiYoutube,
  FiColumns,
  FiAlignLeft,
  FiArrowRight,
  FiMaximize,
  FiMinimize,
  FiLogOut,
  FiUserX,
  FiXCircle,
} from "react-icons/fi";
import { IoIosCheckmarkCircle, IoIosTrendingUp } from "react-icons/io";
import {
  IoHomeOutline,
  IoCallOutline,
  IoCalendarOutline,
  IoPricetagOutline,
  IoShareSocial,
  IoCloudDownloadOutline,
  IoBookOutline,
} from "react-icons/io5";
import {
  FaTasks,
  FaWhatsapp,
  FaRegBuilding,
  FaRegStickyNote,
  FaRegHeart,
  FaRegCheckCircle,
} from "react-icons/fa";
import {
  MdPendingActions,
  MdNumbers,
  MdOutlineGroups3,
  MdOutlinePassword,
  MdConstruction,
  MdOutlinePerson3,
  MdOutlineRoomPreferences,
  MdLowPriority,
  MdOutlineCampaign,
  MdBlock,
} from "react-icons/md";
import { HiOutlineUserGroup } from "react-icons/hi2";
import { HiOutlineDocumentReport } from "react-icons/hi";
import {
  CiFilter,
  CiImageOn,
  CiMap,
  CiMapPin,
  CiCirclePlus,
  CiCircleMinus,
} from "react-icons/ci";
import { GoTasklist, GoProjectRoadmap, GoArrowUpRight } from "react-icons/go";
import { GiTeamUpgrade, GiModernCity, GiAges } from "react-icons/gi";
import { TbUsersGroup } from "react-icons/tb";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { BiCategory, BiTransferAlt } from "react-icons/bi";
import { GrProjects } from "react-icons/gr";
import { TiChartAreaOutline } from "react-icons/ti";
import { LuMapPin } from "react-icons/lu";
import {
  PiElevator,
  PiAddressBook,
  PiGraduationCapThin,
  PiUniteSquare,
} from "react-icons/pi";
import { RiMoneyRupeeCircleLine } from "react-icons/ri";
import { SiStagetimer } from "react-icons/si";
import { VscSourceControl } from "react-icons/vsc";
import { TiTick } from "react-icons/ti";

const getIcon = (name) => {
  switch (name) {
    case "fa-play":
      return <FaPlay />;
    case "io-book":
      return <IoBookOutline />;
    case "go-arrow-up":
      return <GoArrowUpRight />;
    case "fa-x-circle":
      return <FiXCircle />;
    case "fa-check-circle":
      return <FaRegCheckCircle />;
    case "lu-map":
      return <LuMapPin />;
    case "fa-heart":
      return <FaRegHeart />;
    case "feather-user-x":
      return <FiUserX />;
    case "io-trending":
      return <IoIosTrendingUp />;
    case "pi-unit":
      return <PiUniteSquare />;
    case "vs-source":
      return <VscSourceControl />;
    case "md-block":
      return <MdBlock />;
    case "ti-tick":
      return <TiTick />;
    case "si-status":
      return <SiStagetimer />;
    case "bi-transfer":
      return <BiTransferAlt />;
    case "md-campaign":
      return <MdOutlineCampaign />;
    case "io-coshare":
      return <IoShareSocial />;
    case "io-download":
      return <IoCloudDownloadOutline />;
    case "fi-column":
      return <FiColumns />;
    case "md-person":
      return <MdOutlinePerson3 />;
    case "md-password":
      return <MdOutlinePassword />;
    case "pi-graduation":
      return <PiGraduationCapThin />;
    case "gi-age":
      return <GiAges />;
    case "md-preference":
      return <MdOutlineRoomPreferences />;
    case "md-priority":
      return <MdLowPriority />;

    case "md-construction":
      return <MdConstruction />;
    case "ri-rupee":
      return <RiMoneyRupeeCircleLine />;
    case "ci-image":
      return <CiImageOn />;
    case "pi-address":
      return <PiAddressBook />;
    case "md-numbers":
      return <MdNumbers />;
    case "go-projectmap":
      return <GoProjectRoadmap />;
    case "fa-building":
      return <FaRegBuilding />;
    case "fa-stickynote":
      return <FaRegStickyNote />;
    case "bi-category":
      return <BiCategory />;
    case "gr-project":
      return <GrProjects />;
    case "ci-filter":
      return <CiFilter />;
    case "ci-mappin":
      return <CiMapPin />;
    case "gi-city":
      return <GiModernCity />;
    case "ci-map":
      return <CiMap />;
    case "io-pricetag":
      return <IoPricetagOutline />;
    case "bs-building":
      return <BsBuilding />;
    case "ti-chart":
      return <TiChartAreaOutline />;
    case "pi-lift":
      return <PiElevator />;
    case "ci-minus":
      return <CiCircleMinus />;
    case "ci-plus":
      return <CiCirclePlus />;
    case "md-leads":
      return <TbUsersGroup />;
    case "ai-opportunity":
      return <AiOutlineUsergroupAdd />;
    case "gi-team":
      return <GiTeamUpgrade />;
    case "go-task":
      return <GoTasklist />;
    case "io-calendar":
      return <IoCalendarOutline />;
    case "io-call":
      return <IoCallOutline />;
    case "bs-arrow-left":
      return <BsArrowLeft />;
    case "bs-arrow-right":
      return <BsArrowRight />;
    case "fa-whatsapp":
      return <FaWhatsapp />;
    case "fa-report":
      return <HiOutlineDocumentReport />;
    case "fa-team-type":
      return <MdOutlineGroups3 />;
    case "fa-lead":
      return <HiOutlineUserGroup />;
    case "feather-moon":
      return <FiMoon />;
    case "feather-align-left":
      return <FiAlignLeft />;
    case "feather-arrow-right":
      return <FiArrowRight />;
    case "feather-maximize":
      return <FiMaximize />;
    case "feather-minimize":
      return <FiMinimize />;
    case "feather-logout":
      return <FiLogOut />;
    case "feather-sunrise":
      return <FiSunrise />;
    case "feather-sun":
      return <FiSun />;
    case "feather-users":
      return <FiUsers />;
    case "feather-user":
      return <FiUser />;
    case "feather-user-check":
      return <FiUserCheck />;
    case "feather-user-plus":
      return <FiUserPlus />;
    case "feather-user-minus":
      return <FiUserMinus />;
    case "feather-arrow-up":
      return <FiArrowUp />;
    case "feather-arrow-down":
      return <FiArrowDown />;
    case "feather-at-sign":
      return <FiAtSign />;
    case "feather-globe":
      return <FiGlobe />;
    case "feather-lock":
      return <FiLock />;
    case "feather-settings":
      return <FiSettings />;
    case "feather-smart-phone":
      return <FiSmartphone />;
    case "feather-bell":
      return <FiBell />;
    case "feather-mail":
      return <FiMail />;
    case "feather-repeat":
      return <FiRepeat />;
    case "feather-bell-off":
      return <FiBellOff />;
    case "feather-link-2":
      return <FiLink2 />;
    case "feather-phone":
      return <FiPhone />;
    case "feather-compass":
      return <FiCompass />;
    case "feather-briefcase":
      return <FiBriefcase />;
    case "feather-link":
      return <FiLink />;
    case "feather-map-pin":
      return <FiMapPin />;
    case "feather-type":
      return <FiType />;
    case "feather-dollar-sign":
      return <FiDollarSign />;
    case "feather-eye":
      return <FiEye />;
    case "feather-eye-off":
      return <FiEyeOff />;
    case "feather-tag":
      return <FiTag />;
    case "feather-message-square":
      return <FiMessageSquare />;
    case "feather-search":
      return <FiSearch />;
    case "feather-linkedin":
      return <FiLinkedin />;
    case "feather-instagram":
      return <FiInstagram />;
    case "feather-twitter":
      return <FiTwitter />;
    case "feather-facebook":
      return <FiFacebook />;
    case "feather-github":
      return <FiGithub />;
    case "feather-shield":
      return <FiShield />;
    case "feather-log-in":
      return <FiLogIn />;
    case "feather-clipboard":
      return <FiClipboard />;
    case "feather-check":
      return <FiCheck />;
    case "feather-x":
      return <FiX />;
    case "feather-cast":
      return <FiCast />;
    case "feather-activity":
      return <FiActivity />;
    case "feather-check-circle":
      return <IoIosCheckmarkCircle />;
    case "feather-pie-chart":
      return <FiPieChart />;
    case "feather-plus-square":
      return <FiPlusSquare />;
    case "feather-sunset":
      return <FiSunset />;
    case "feather-power":
      return <FiPower />;
    case "feather-alert-circle":
      return <FiAlertCircle />;
    case "feather-layout":
      return <FiLayout />;
    case "feather-send":
      return <FiSend />;
    case "feather-grid":
      return <FiGrid />;
    case "feather-youtube":
      return <FiYoutube />;
    case "feather-copy":
      return <FiCopy />;
    case "feather-edit":
      return <FiEdit />;
    case "feather-pause":
      return <FiPause />;
    case "feather-star":
      return <FiStar />;
    case "feather-delete":
      return <FiDelete />;
    case "feather-trash-2":
      return <FiTrash2 />;
    case "feather-git-commit":
      return <FiGitCommit />;
    case "feather-airplay":
      return <FiAirplay />;
    case "feather-clock":
      return <FiClock />;
    case "feather-crosshair":
      return <FiCrosshair />;
    case "feather-life-buoy":
      return <FiLifeBuoy />;
    case "feather-git-branch":
      return <FiGitBranch />;
    case "feather-help-circle":
      return <FiHelpCircle />;
    case "feather-archive":
      return <FiArchive />;
    case "feather-award":
      return <FiAward />;
    case "feather-bar-chart-2":
      return <FiBarChart2 />;
    case "feather-shopping-bag":
      return <FiShoppingBag />;
    case "feather-shopping-cart":
      return <FiShoppingCart />;
    case "feather-figma":
      return <FiFigma />;
    case "feather-gitlab":
      return <FiGitlab />;
    case "feather-bluetooth":
      return <FiBluetooth />;
    case "feather-file-text":
      return <FiFileText />;
    case "feather-monitor":
      return <FiMonitor />;
    case "feather-smartphone":
      return <FiSmartphone />;
    case "feather-tablet":
      return <FiTablet />;
    case "feather-layers":
      return <FiLayers />;
    case "feather-list":
      return <FiList />;
    case "feather-umbrella":
      return <FiUmbrella />;
    case "feather-sliders":
      return <FiSliders />;
    case "feather-framer":
      return <FiFramer />;

    case "fa-chrome":
      return <FaChrome />;
    case "fa-firefox-browser":
      return <FaFirefoxBrowser />;
    case "fa-safari":
      return <FaSafari />;
    case "fa-edge":
      return <FaEdge />;
    case "fa-opera":
      return <FaOpera />;
    case "fa-internet-explorer":
      return <FaInternetExplorer />;
    case "fa-octopus-deploy":
      return <FaOctopusDeploy />;
    case "fa-cc-visa":
      return <FaCcVisa />;
    case "fa-cc-mastercard":
      return <FaCcMastercard />;
    case "fa-cc-paypal":
      return <FaCcPaypal />;
    case "fa-facebook":
      return <FaFacebook />;
    case "fa-twitter":
      return <FaTwitter />;
    case "fa-youtube":
      return <FaYoutube />;
    case "fa-linkedin":
      return <FaLinkedin />;
    case "fa-briefcase":
      return <FaBriefcase />;
    case "fa-home":
      return <IoHomeOutline />;
    case "fa-users":
      return <FaUsers />;
    case "fa-plane":
      return <FaPlane />;
    case "fa-lock":
      return <FaLock />;
    case "fa-umbrella-beach":
      return <FaUmbrellaBeach />;
    case "fa-building":
      return <FaBuilding />;
    case "fa-birthday-cake":
      return <FaCakeCandles />;

    case "bi-envelope-plus":
      return <BsEnvelopePlus />;
    case "bi-envelope-check":
      return <BsEnvelopeCheck />;
    case "bi-envelope-open":
      return <BsEnvelopeOpen />;
    case "bi-envelope-heart":
      return <BsEnvelopeHeart />;
    case "bi-envelope-slash":
      return <BsEnvelopeSlash />;
    case "bi-envelope-close":
      return <BsEnvelope />;

    case "fa-task":
      return <FaTasks />;

    case "bs-task":
      return <BsListTask />;
    case "md-pending":
      return <MdPendingActions />;

    default:
      break;
  }
};
export default getIcon;
